import http from '../utils/https';

/**
 * 获取图形验证码
 * @returns {Promise} 包含验证码图片数据的 axios Promise 对象
 */
export function getCaptchaImage() {
	return http.get('/api/captcha/captchaImage', {
		params: { type: 'math' },
		// axios请求中设置responseType为'blob'，这样axios才能正确解析图像数据。
		responseType: 'blob' // 添加响应类型声明
	});
}

/**
 * 渠道合作伙伴认证验证
 * @param {string} authCode 渠道授权码
 * @param {string} validateCode 图形验证码
 * @returns {Promise} axios Promise 对象
 */
export function chanelVerify({ authCode, validateCode }) {
	return http.get('/api/common/channel/partner/auth/verifi', {
		params: { authCode, validateCode }
	});
}

/**
 * 防伪码验证接口
 * @param {string} authCode 防伪码
 * @param {string} validateCode 验证码
 * @returns {Promise} axios Promise 对象
 */
export function antiCounterfeitingCodeVerify({ authCode, validateCode }) {
	return http.get('/api/common/verifyAntiCounterfeitingCode', {
		params: { authCode, validateCode }
	});
}

/**
 * 获取防伪查询维护时间配置
 * @returns {Promise}
 */
export function getWmsUpdateTime() {
	return http.get('/api/system/config/getWmsUpdateTime');
}
